import { Component, inject, Input } from '@angular/core';
import { FormBuilder, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { debounceTime, distinctUntilChanged, Subject, takeUntil, tap } from 'rxjs';
import { TokenSession } from '../../../core/models/users.interface';
import { LayoutService } from '../../../core/services/layout/layout';
import { AuthService } from '../../../core/services/auth/auth';
import { ActivatedRoute, Router } from '@angular/router';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
  selector: 'app-search',
  imports: [
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatProgressSpinnerModule,
    MatInputModule,
    MatIconModule,
  ],
  templateUrl: './search.html',
  styleUrl: './search.css',
})
export class Search {
  search = '';
  showSearch = true;
  userSession: TokenSession | null = null;
  @Input() placeholder: string = 'Buscar...';
  protected _onDestroy = new Subject<void>();
  isLoadingInput = false;
  private formBuilder = inject(FormBuilder);

  constructor(
    private layoutService: LayoutService,
    private authService: AuthService,
    private route: ActivatedRoute,
    private router: Router,
  ) {}

  searchForm = this.formBuilder.group({
    search: [''],
  });

  ngOnInit(): void {
    this.route.queryParamMap.subscribe((params) => {
      const search = params.get('search');
      if (search) {
        this.search = search;
        this.layoutService.setSearch(search);
        this.searchForm.get('search')?.setValue(search);
      }
    });
    this.searchForm
      .get('search')
      ?.valueChanges.pipe(
        tap(() => {
          this.isLoadingInput = true;
        }),
        debounceTime(1500),
        tap(() => {
          this.isLoadingInput = false;
        }),
        distinctUntilChanged(),
        takeUntil(this._onDestroy),
      )
      .subscribe((value) => {
        this.layoutService.setSearch(value);
        this.router.navigate([], {
          relativeTo: this.route,
          queryParams: { search: value || null },
          queryParamsHandling: 'merge',
        });
      });

    this.layoutService.showSearch$.subscribe((show) => (this.showSearch = show));
    this.authService.token$.subscribe((token) => (this.userSession = token));
    this.layoutService.search$.subscribe((keywords) => {
      if (keywords !== null && keywords !== undefined) {
        this.search = keywords;
      }
    });
  }

  ngOnDestroy() {
    this._onDestroy.next();
    this._onDestroy.complete();
  }
}
